<template>
  <div
    v-bind:style="{
      'max-width': screenWidth + 'px',
    }"
    class="bar"
  >
    <div v-for="(video, index) in videos" :key="index">
      <div
        @click="onVideo(video)"
        :class="{
          'section-normal': video._id !== currentVideo,
          'section-selected': video._id === currentVideo,
        }"
      >
        <label class="chapter-title">{{ video.title }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ControlBar',
  data() {
    return {
      screenWidth: Math.min(window.innerWidth, 1024),
      currentVideo: undefined,
    };
  },
  props: {
    videos: Array,
    onSection: Function,
  },
  mounted() {
    this.currentVideo = this.videos[0]._id;
  },
  methods: {
    onVideo(video) {
      if (video._id !== this.currentVideo) {
        this.currentVideo = video._id;
        this.onSection(video.video_id);
      }
    },
  },
};
</script>

<style scoped>
.bar {
  box-sizing: border-box;
  height: 70px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  overflow: scroll;
  padding: 10px 0 10px 15px;
}

.bar::-webkit-scrollbar {
  display: none;
}

.section-normal {
  width: 100px;
  height: 50px;
  margin-right: 15px;
  border-radius: 4px;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  align-items: flex-start;
  padding: 5px;
  box-sizing: border-box;
  font-size: 12px;
  color: #333;
  border: 1px solid #ccc;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.section-selected {
  width: 100px;
  height: 50px;
  margin-right: 15px;
  border-radius: 4px;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  align-items: flex-start;
  padding: 5px;
  box-sizing: border-box;
  font-size: 12px;
  color: #49afad;
  border: 1px solid #49afad;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.chapter-title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
